import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './AuthorizeController.json';

const validateAndSendOTP = (req, res, ctx) => {
  const responseData = MOCK_DATA['AuthorizeController/validateAndSendOTP'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const getLoginStatus = (req, res, ctx) => {
  const responseData = MOCK_DATA['authorizationController/getLoginStatus'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('AuthorizeController/validateAndSendOTP'), withScenario(withAuthCheck(validateAndSendOTP))),
  rest.post(getApiEndpoint('authorizationController/getLoginStatus'), withScenario(withAuthCheck(getLoginStatus))),
];
